import { Badge } from "@/components/ui/badge";
import { BUCKET_LABELS, BUCKET_COLORS, FOLLOWUP_STATUS_LABELS, FOLLOWUP_STATUS_COLORS, daysOverdueLabel } from "@/lib/followupConstants";

/** Badges de urgencia (bucket) + estado de seguimiento, reusados en el panel
 * de Seguimiento y en la ficha del paciente. */
export default function FollowUpBadge({ bucket, daysOverdue, followUpStatus, testId }) {
  const bucketColor = BUCKET_COLORS[bucket] || BUCKET_COLORS.upcoming;
  const statusColor = FOLLOWUP_STATUS_COLORS[followUpStatus] || FOLLOWUP_STATUS_COLORS.pending;

  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid={testId}>
      <Badge className="border-none font-normal text-[11px]" style={{ backgroundColor: bucketColor.bg, color: bucketColor.text }}>
        {BUCKET_LABELS[bucket] || bucket} &middot; {daysOverdueLabel(daysOverdue)}
      </Badge>
      {followUpStatus && followUpStatus !== "pending" && (
        <Badge className="border-none font-normal text-[11px]" style={{ backgroundColor: statusColor.bg, color: statusColor.text }}>
          {FOLLOWUP_STATUS_LABELS[followUpStatus] || followUpStatus}
        </Badge>
      )}
    </div>
  );
}
